import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../../utils/Customer/apiBaseQuery";

import { IAnalyticsEventRequest } from "../../../types/Request/AnalyticsRequest";

import { ANALYTICS_EVENTS } from "../../../config/apiUrlsAdmin";

export const analyticsApi = createApi({
  reducerPath: "analyticsApi",

  baseQuery: axiosBaseQuery(),

  endpoints: (builder) => ({
    trackAnalyticsEvent: builder.mutation<
      {
        success: boolean;
        message: string;
      },
      IAnalyticsEventRequest
    >({
      query: (data) => ({
        url: ANALYTICS_EVENTS,
        method: "post",
        data,
      }),
    }),
  }),
});

export const { useTrackAnalyticsEventMutation } = analyticsApi;
